import axios from '@/util/request'
import store from '@/store'
// import { report } from '@/util/dataReport.js'

const baseURL = process.env.VUE_APP_API_URL

export default {
  // 现货页面
  getProductList: data => axios({ baseURL, url: store.state.common.token ? '/api/product/list' : '/api/product/open/product/list', method: 'post', data }), // 商品列表
  getSeoBusinessId: params => axios({ baseURL, url: `/api/product/open/seo/businessId`, method: 'get', params }), // 前台-根据品类网址（关键词）获取品类ID

  getMaterialList: params => axios({ baseURL, url: '/api/product/open/materialByCategory', params }), // 材质
  getCategoryList: params => axios({ baseURL, url: '/api/product/open/category/list', params }), // 品类
  getShippingFromList: params => axios({ baseURL, url: '/api/product/open/warehouse/list', params }), // 发货地下拉列表
  getDateLine: () => axios({ baseURL, url: '/api/product/open/dateLine', method: 'POST' }), // 发货地下拉列表
  getSearches: params => axios({ baseURL, url: '/api/report/open/hotSearchTerms', params }), // 热门搜索词列表
  getSizeList: data => axios({ baseURL, url: '/api/product/open/sizeList', method: 'post', data }), // 商品尺码列表
  // getSearches: params => axios({ baseURL, url: '/api/report/hotSearchTerms', params }), // 热门搜索词列表
  suggestionCompletion: data => axios({ baseURL, url: '/api/product/open/suggestionCompletion', method: 'post', data }), // 用户搜索推荐

  // 商品详情
  // getProductDetail: id => axios({ baseURL, url: `/api/product/open/details/${id}` }), // 获取商品详情
  getProductDetail: params => axios({ baseURL, url: `/api/product/open/details`, method: 'get', params }), // 获取商品详情
  searchProductSimilarImgList: data => axios({ baseURL, url: `/api/product/open/recommend/searchProductSimilarImgList`, method: 'post', data }), // 以图搜图商品详情相似款列表
  addProductList: kkProductId => {
    return new Promise((resolve, reject) => {
      axios({ baseURL, url: `/api/product/collect/add/${kkProductId}`, method: 'POST' }).then(result => {
        resolve(result)
        // report(18, JSON.stringify({ kkProductId }))
        window.ttq && window.ttq.track('AddToWishlist')
      }).catch(error => {
        reject(error)
      })
    })
  }, // 添加到产品列表
  // 评分相关
  searchProductGetProductReviewList: data => axios({ baseURL, url: `/api/product/open/getProductReviewList`, method: 'post', data }), // 获取商品评论列表(带分页)
  searchProductGetProductReviewStarPercent: data => axios({ baseURL, url: `/api/product/open/getProductReviewStarPercent`, method: 'post', data }), // 获取商品评论星级比例
  searchProductProductReviewAdd: data => axios({ baseURL, url: `/api/product/open/productReview`, method: 'post', data }), // 新增商品评论

  getCategoryByProduct: (id) => axios({ baseURL, url: `/api/product/open/getCategoryByProduct/${id}`, method: 'get' }), // spu品类全路径

  // 购物车
  getCartList: (data = {}) => axios({ baseURL, url: '/api/product/cart/list', method: 'post', data }), // 获取购物车列表
  addCart: data => {
    return new Promise((resolve, reject) => {
      axios({ baseURL, url: '/api/product/cart/add', method: 'POST', data }).then(result => {
        resolve(result)
        // report(17, JSON.stringify(data))
        window.ttq && window.ttq.track('AddToCart')
      }).catch(error => {
        reject(error)
      })
    })
  }, // 添加到购物车
  updateCartNumber: data => axios({ baseURL, url: '/api/product/cart/num', method: 'PUT', data }), // 修改购物车数量
  deleteCart: data => axios({ baseURL, url: `/api/product/cart/delete`, method: 'DELETE', data }), // 删除购物车
  addBatchCart: data => {
    return new Promise((resolve, reject) => {
      axios({ baseURL, url: '/api/product/cart/addBatch', method: 'POST', data }).then(result => {
        resolve(result)
        // report(17, JSON.stringify(data))
        window.ttq && window.ttq.track('AddToCart')
      }).catch(error => {
        reject(error)
      })
    })
  }, // 添加到购物车

  getOrderBillingPreviewInfo: (data) => axios({ baseURL, url: '/api/product/orderBillingPreviewInfo', method: 'post', data }), // TODO 购物车（订单）获取订单预览信息

  // 未登录根据商品获取购物车信息
  logoutCartList: data => { // axios({ baseURL, url: '/api/product/open/buildCartList', method: 'POST', data }),
    return new Promise((resolve, reject) => {
      axios({ baseURL, url: '/api/product/open/buildCartList', method: 'POST', data }).then(result => {
        resolve(result)
        // report(17, JSON.stringify(data))
        window.ttq && window.ttq.track('AddToCart')
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 普通用户快捷注册
  logoutSignUp: data => axios({ baseURL, url: '/api/store/open/v2/signUp', method: 'POST', data }),

  createOrder: data => {
    return new Promise((resolve, reject) => {
      axios({ baseURL, url: `/api/orders/orders`, method: 'POST', data }).then(result => {
        resolve(result)
        window.ttq && window.ttq.track('PlaceAnOrder')
      }).catch(error => {
        reject(error)
      })
    })
  }, // 创建订单
  // 下单时-查询详情
  orderGetDetailToPay: kkOrderId => axios({ baseURL, url: `/api/orders/orders/place/${kkOrderId}`, method: 'get' }),
  orderChangeAddress: data => axios({ baseURL, url: `/api/orders/orders/addresses/${data.kkOrderId}`, method: 'put', data: data.data }),
  orderChangeChannel: data => axios({ baseURL, url: `/api/orders/orders/channel/${data.kkOrderId}`, method: 'put', data: data.data }),
  // 修改订单备注
  orderChangeRemark: data => axios({ baseURL, url: `/api/orders/orders/remark/${data.kkOrderId}`, method: 'put', data: data.data }),

  // 获取游客token
  getVisitorToken: data => axios({ baseURL, url: '/api/system/open/visitor', method: 'get', data }),

  // TODO 此方法名称重复
  couponCodeCheck: data => axios({ baseURL, url: `/api/product/open/coupon/couponCodeCheck`, method: 'POST', data }), // 优惠码校验

  createTransactionOrder: data => axios({ baseURL, url: `/api/payment/transaction`, method: 'POST', data }), // 创建交易单
  getOrderBatchSum: data => axios({ baseURL, url: `/api/orders/orders/sum`, method: 'POST', data }), // 查询订单汇总金额
  // getOrderState: id => axios({ baseURL, url: `/api/payment/transaction/${id}` }), // 获取订单状态 (旧的)
  getOrderState: id => axios({ baseURL, url: `/api/payment/transaction/${id}/status` }), // 获取订单状态
  getLogisticsChannel: data => axios({ baseURL, url: `/api/orders/open/channel`, method: 'POST', data }), // 获取物流渠道
  balancePayment: paymentId => axios({ baseURL, url: `/api/payment/balance/${paymentId}`, method: 'POST' }), // 余额付款
  getQianHaiSignValue: data => axios({ baseURL, url: `/api/payment/ocean/onePage/signValue`, method: 'POST', data }), // 获取前海signValue
  getAirwallexPaymentIntent: (paymentId, data) => axios({ baseURL, url: `/api/payment/airwallex/paymentIntent/${paymentId}`, method: 'POST', data }), // 空中云汇创建PaymentIntent
  getPaymentPayoneer: (data) => axios({ baseURL, url: `/api/payment/payoneer/lists`, method: 'POST', data }), // 生成 payoneer 支付链接地址
  getPayoneerCallback: (longId) => axios({ baseURL, url: `/api/payment/payoneer/charge/${longId}/callback`, method: 'PUT' }), // 前台-payoneer支付回调
  getSimilarProductRecommendList: (params, kkProductId) => axios({ baseURL, url: `/api/product/open/recommend/contentBased/${kkProductId}`, params }), // 类似商品推荐列表
  getProductAttributeList: data => axios({ baseURL, url: `/api/product/open/attribute`, data, method: 'post' }), // 获取商品属性列表
  getInsList: data => axios({ baseURL, url: '/api/product/open/recommend/insList', method: 'post', data }), // 知衣ins
  getInsInfo: params => axios({ baseURL, url: '/api/product/open/recommend/insInfo', method: 'get', params }), // 知衣ins详情
  getInsTagMenu: () => axios({ baseURL, url: '/api/product/open/recommend/insTagMenu', method: 'get' }) // 知衣搜索菜单
}
